export const MarketPriceEstimationData = [
  {
    value: 'H',
    label: '추정 정확도 높음',
  },
  {
    value: 'M',
    label: '추정 정확도 보통',
  },
];

export const AppraisalPointData = [
  {
    value: 'B',
    label: '6개월 이내',
  },
  {
    value: 'C',
    label: '6~12개월',
  },
  {
    value: 'D',
    label: '12개월 이상',
  },
];

export const NumberOfFailedBidData = [
  {
    value: '0',
    label: '신건',
  },
  {
    value: '1',
    label: '1회 이하',
  },
  {
    value: '2',
    label: '2회 이하',
  },
  {
    value: '3',
    label: '3회 이하',
  },
  {
    value: '4',
    label: '4회 이하',
  },
  {
    value: '5',
    label: '5회 이상',
  },
];

export const OldAgeData = [
  {
    value: 'B',
    label: '5년 이내',
  },
  {
    value: 'C',
    label: '5~10년',
  },
  {
    value: 'D',
    label: '10~15년',
  },
  {
    value: 'E',
    label: '15~20년',
  },
  {
    value: 'F',
    label: '20~30년',
  },
  {
    value: 'G',
    label: '30년 이상',
  },
];

export const SalesDaysData = [
  {
    value: 'B',
    label: '3개월 이내',
  },
  {
    value: 'C',
    label: '6개월 이내',
  },
  {
    value: 'D',
    label: '12개월 이내',
  },
  {
    value: 'E',
    label: '12개월 이상',
  },
];

export const RealReturnData = [
  {
    value: '~10% 수익',
    label: '~10% 수익',
  },
  {
    value: '10~30% 수익',
    label: '10~30% 수익',
  },
  {
    value: '30~50% 수익',
    label: '30~50% 수익',
  },
  {
    value: '50~100% 수익',
    label: '50~100% 수익',
  },
  {
    value: '100% 이상 수익',
    label: '100% 이상 수익',
  },
];

export const InitialInvestOptions = {
  pnu: '',
  region: { sido: '', sigungu: '', emd: '' },
  category: '',
  categoryDetail: '',
  investmentPeriod: 'A',
  investmentPurpose: 'A',
  aging_start_year: '',
  aging_end_year: '',
  useArea: [],
};

export const InitialProfitOptions = {
  revenueType: 'A',
  costIncluded: 'N',
  investmentType: 'A',
  minInvestmentValue: '',
  maxInvestmentValue: '',
  investmentRate: '',
  profitRate: 'A',
  customBidCnt: false,
  minBidCnt: '',
  maxBidCnt: '',
  isRisk: false,
  risk: [],
  prcReliability: 'B',
  auctionDateYears: '5',
  profitStatus: 'B',
  valueStatus: 'B',
};

export const investmentPeriodOptions = [
  { value: 'B', label: '단기', description: '12개월 미만' },
  { value: 'C', label: '장기', description: '12개월 이상' },
];

export const investmentPurposeOptions = [
  { value: 'A', label: '선택 안 함' },
  { value: 'B', label: '매매/임대' },
  { value: 'C', label: '건축/개발' },
  { value: 'D', label: '실거주' },
];

export const revenueTypeOptions = [
  { value: 'A', label: '매각차익' },
  { value: 'B', label: '임대수익' },
];

export const investmentTypeOptions = [
  { value: 'A', label: '선택안함' },
  { value: 'B', label: '투자원금' },
  { value: 'C', label: '대출금' },
];

export const profitRateOptions = [
  {
    value: 'B',
    label: '0%',
    description: '유찰 0회 이상',
  },
  {
    value: 'C',
    label: '20~30%',
    description: '유찰 1회 이상',
  },
  {
    value: 'D',
    label: '30~50%',
    description: '유찰 2회 이상',
  },
  {
    value: 'E',
    label: '50% 이상',
    description: '유찰 3회 이상',
  },
];

export const listTypeOptions = [
  { value: false, label: '위험 회피' },
  { value: true, label: '위험 감수' },
];

export const riskSelectOptions = [
  { value: 'all', label: '전체' },
  { value: 'HUG인수조건변경', label: 'HUG인수조건변경' },
  { value: '임차인 대항력', label: '임차인 대항력' },
  { value: '임금채권', label: '임금채권' },
  { value: '재매각', label: '재매각' },
  { value: '위반건축물', label: '위반건축물' },
  { value: '법정지상권', label: '법정지상권' },
  { value: '분묘기지권', label: '분묘기지권' },
  { value: '유치권', label: '유치권' },
];

export const prcReliabilityOptions = [
  {
    value: 'C',
    label: '높음',
    description: '감정시점, \n주변 및 최근 사례 반영',
  },
  {
    value: 'B',
    label: '무관',
    description: '감정시점, \n주변 및 최근 사례 미반영',
  },
];

export const auctionDateYearsOptions = [
  { value: '0', label: '전체 사례' },
  { value: '3', label: '최근 3년 이내' },
  { value: '5', label: '최근 5년 이내' },
  { value: '10', label: '최근 10년 이내' },
  { value: '20', label: '최근 20년 이내' },
];

export const profitStatusOptions = [
  { value: 'A', label: '전체', description: '무관' },
  { value: 'B', label: '차익 有', description: '낙찰가 < 매각가' },
  { value: 'C', label: '차익 無', description: '낙찰가 > 매각가' },
];

export const valueStatusOptions = [
  { value: 'A', label: '전체', description: '무관' },
  { value: 'B', label: '저평가', description: '시세 > 감정가' },
  { value: 'C', label: '고평가', description: '시세 < 감정가' },
];

export const periodMap: Record<string, string> = {
  B: '단기',
  C: '장기',
};

export const purposeMap: Record<string, string> = {
  B: '매매/임대',
  C: '건축/개발',
  D: '실거주',
};

export const revenueTypeMap: Record<string, string> = {
  A: '매각차익',
  B: '임대수익',
};

export const investmentTypeMap: Record<string, string> = {
  B: '투자원금',
  C: '대출금',
};

export const profitRateMap: Record<string, string> = {
  B: '0%',
  C: '20~30%',
  D: '30~50%',
  E: '50% 이상',
};

export const prcReliabilityMap: Record<string, string> = {
  B: '무관',
  C: '높음',
};

export const profitStatusMap: Record<string, string> = {
  A: '전체',
  B: '차익 有 (낙찰가 < 매각가)',
  C: '차익 無 (낙찰가 > 매각가)',
};

export const valueStatusMap: Record<string, string> = {
  A: '전체',
  B: '저평가 (시세 > 감정가)',
  C: '고평가 (시세 < 감정가)',
};
